import { Auth, Businesses } from 'api';
import cookie from 'react-cookie';

function postLogin(res, isRememberMe) {
  return function(dispatch) {
    if (res && res.data) {
      let expiresParams = {path: '/'};
      if (isRememberMe) {
       expiresParams = {path: '/', maxAge: 3600*24*365};
      }

      cookie.save('accessToken', res.data.id, expiresParams);
      return dispatch(getUserInfo()).then(response => {
        return {
          isAuthenticated: true,
          data: response,
          isAdmin: response.isAdmin
        }
      });
    } else {
      return {
        isAuthenticated: false,
        data: "Invalid response data"
      }
      console.log('Invalid response data');
    }
  }
}
function login(username, password, isRememberMe) {
  return function(dispatch) {
    return Auth.actions.signin.request(null, {
      data: {
        email: username,
        password: password
      }
    }).then(res => {
      return dispatch(postLogin(res, isRememberMe));
    }).catch( (errors) => {
      return {
        isAuthenticated: false,
        data: errors.response
      }
    });
  }
}

function switchMainBusiness(businessId) {
  return function(dispatch) {
    return User.actions.switchMainBusiness.request({businessId}).then(res => {
      dispatch({
        type: 'UPDATE_MAIN_BUSINESS',
        business: res.data
      });

      return res;
    });
  }
}

function signinWithTicket(ticketId) {
  return function(dispatch) {
    return Auth.actions.signinWithTicket.request({id: ticketId},{
    }).then(res => {
      return dispatch(postSigninWithTicket(res));
    }).catch( (errors) => {
      return {
        isAuthenticated: false,
        data: errors.response
      };
    });
  };
}

function postSigninWithTicket(res) {
  return function(dispatch) {
    if (
      res &&
      res.data &&
      res.data.data &&
      res.data.accessToken
    ) {
      let expiresParams = {path: '/', maxAge: 3600*24*365};

      cookie.save('accessToken', res.data.accessToken.id, expiresParams);
      return dispatch(getUserInfo()).then(response => {
        return {
          isAuthenticated: true,
          data: response,
          isAdmin: response.isAdmin,
          businessData: res.data.data
        };
      });
    }
    return {
      isAuthenticated: false,
      data: "Invalid response data"
    };
  };
}

function loginToBusinessOwner(adminUser, adminPass, businessId) {
  return function(dispatch) {

    return Auth.actions.signinToBusinessOwner.request(null, {
      data: {
        email: adminUser,
        password: adminPass,
        businessId
      }
    }).then(res => {
      return dispatch(postLogin(res, false)).then(response => {
        return dispatch(switchMainBusiness(businessId)).then(businessRes => {
          return {
            ...response,
            business: businessRes.data
          }
        })
      });
    }).catch( (errors) => {
      return {
        isAuthenticated: false,
        data: errors.response
      }
    });
  }
}

function isAdmin() {
  return function(dispatch) {
    return dispatch(getUserInfo()).then(response => {
      if (response.roles == 'super_admin') {
        return {
          isAuthenticated: true
        };
      }
      else {
        return {
          isAuthenticated: false
        };
      }
    })
  }
}

function storeUserInfo(user) {
  return function(dispatch) {
    return new Promise((resolve, reject) => {
      dispatch({
        type: 'CURRENT_USER',
        user
      });

      return resolve(user);
    });

  }
}

function storeBusinessInfo(businesses, mainBusiness) {
  return function(dispatch) {
    return new Promise((resolve, reject) => {
      dispatch({
        type: 'UPDATE_MY_BUSINESS_LIST',
        businesses,
        mainBusiness
      });

      return resolve(businesses);
    });

  }
}

function getUserInfo() {

  return function(dispatch) {
    return Auth.actions.me.request().then(res => {
      let isAdmin = false;
      res.data.roles && res.data.roles.length > 0 && res.data.roles.map(role => {
        if (role.name == 'admin') {
          isAdmin = true;
        }
      });

      res.data.isAdmin = isAdmin;

      if (res.data.mainBusiness) {
        return dispatch(getBusinessInPavo(res.data.id, res.data.mainBusiness.id, res.data, isAdmin))
      } else {
        return dispatch(storeUserInfo(res.data)).then(user => {
          return dispatch(storeBusinessInfo(res.data.businesses, res.data.mainBusiness)).then(business => {
            return {
              ...res.data,
              isAdmin
            }
          });
        });
      }
    }).catch( (errors) => {

      return {
        isAuthenticated: false,
        data: errors
      }
   });
  }
}

function getBusinessInPavo(userId, dntBusinessId, data, isAdmin) {
  return function(dispatch) {
    return Businesses.actions.list.request({filter: {userId}}).then(res => {
      let mainBusiness = data.mainBusiness;
      if(res.data && res.data.length > 0 && res.data.filter(item => item.dntId === 'dnt_' + dntBusinessId).length > 0) {
        let data = res.data.filter(item => item.dntId === 'dnt_' + dntBusinessId)[0]
        mainBusiness.id = data.id;
      }
      return dispatch(storeUserInfo(data)).then(user => {
        return dispatch(storeBusinessInfo(data.businesses, mainBusiness)).then(business => {
          return {
            ...data,
            isAdmin
          }
        });
      });
    }).catch(errors => {
      return dispatch(storeUserInfo(data)).then(user => {
        return dispatch(storeBusinessInfo(data.businesses, data.mainBusiness)).then(business => {
          return {
            ...data,
            isAdmin
          }
        });
      });
    })
  }
}

function logout() {
  return function(dispatch) {
    return Auth.actions.signout.request().then(response => {
      cookie.remove('accessToken', {path: '/'});

      dispatch({
        type: 'LOGOUT'
      });
    });
  }
}

export {login, getUserInfo, logout, isAdmin, storeBusinessInfo, loginToBusinessOwner, signinWithTicket, postSigninWithTicket};



// WEBPACK FOOTER //
// ./actions/auth.js